import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants, FormatConstants } from "services/keyConstants";
import { mamOfEquipmentDownload, mamOfEquipmentList } from "api/module/mamOfEquipment";

// Lazy-loaded components
const MasterListOfEquipment = Loadable(lazy(() => import("../MasterListOfEquipment")));
const ReportDetails = Loadable(lazy(() => import("../ReportDetails")));
const Create = Loadable(lazy(() => import("../Create")));
const CommonDetail = Loadable(lazy(() => import("components/CommonDetail/CommonDetail")));

const documentName = FormatConstants.MAMOFEQUIPMENT.CALIBRATION_PLAN;

const MAMEquipmentRoutes = [
  {
    path: routeConstants.MAM_OF_EQUIPMENT,
    children: [
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item) =>
                `/${routeConstants.MAM_OF_EQUIPMENT}/calibration-report-detail/${item?._id}`,
            }}
            url={{ GET: mamOfEquipmentList, DOWNLOAD: mamOfEquipmentDownload }}
            tableConfig={(item) => ({
              documentName,
              actions:
                item?.defaultName === FormatConstants.MAMOFEQUIPMENT.CALIBRATION_PLAN
                  ? []
                  : undefined,
            })}
            buttonsData={(masterDocData) => {
              return masterDocData?.defaultName === FormatConstants.MAMOFEQUIPMENT.CALIBRATION_PLAN ? [
                {
                  name: "Download",
                  existingFunction: "handleDownload"
                },
              ] : null;
            }}
            downloadConfig={(defaultMasterDocData, item) => {
              if (
                defaultMasterDocData?.defaultName ===
                FormatConstants.MAMOFEQUIPMENT.CALIBRATION_PLAN
              ) {
                return { _id: defaultMasterDocData?.masterDocId };
              }
              return {};
            }}
          />
        ),
      },
      {
        path: "calibration-report-detail/:id",
        element: <ReportDetails />,
      },
      {
        path: "create-calibration-report",
        element: <Create />,
      },
      {
        path: "master-list-of-equipment",
        element: <MasterListOfEquipment />,
      },
    ],
  },
];

export default MAMEquipmentRoutes;
